import { OnDestroy, Component } from '@angular/core';
import { Subject } from 'rxjs';

import { UntypedFormGroup } from '@angular/forms';
import { MessageDialogComponent } from 'app/shared/message-dialog/message-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TextInputDialogComponent } from './text-input-dialog/text-input-dialog.component';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-mytrove',
  template: '',
  styleUrls: []
})
export class TroveComponent implements OnDestroy {

    // Home page of the external brochure site (the marketing/content pages that used
    // to live in this app). Used for logo links across the functional screens.
    readonly brochureUrl = environment.brochureURL;

    ngUnsubscribe: Subject<void> = new Subject<void>();

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    showErrors(form: UntypedFormGroup, formErrors: object, validationMessages: object, ignoreDirty: boolean) {
      if (!form) { return; }

      for (const field of Object.keys(formErrors)) {
        // clear previous error message (if any)
        formErrors[field] = '';
        const control = form.get(field);

        if (control && (control.dirty || ignoreDirty) && !control.valid) {
          const messages = validationMessages[field];
          for (const key of Object.keys(control.errors)) {
            formErrors[field] += messages[key] + ' ';
          }
        }
      }
    }

    showErrorMessage(dialog: MatDialog, message: string) {
      this.showMessage(dialog, 'PROBLEM', message);
    }

    showMessage(dialog: MatDialog, title: string, message: string, button1 = 'OK'): void {
      const dialogRef = dialog.open(MessageDialogComponent, {
        width: '500px',
        data: { title: title, message: message, button1: button1 }
      });
    }

    showOptionsDialog(dialog: MatDialog, title: string, message: string, button1: string, button2: string, onClose?: (buttonPressed: string) => void, width = '320px') {
      const dialogRef = dialog.open(MessageDialogComponent, {
        width: width,
        data: {
          title: title,
          message: message,
          button1: button1,
          button2: button2,
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (onClose) {
          onClose(result);
        }
      });
    }

    showPromptForInputDialog(dialog: MatDialog, title: string, message: string, onClose?: (freeTextValue: string) => void, width = '320px') {
      const dialogRef = dialog.open(TextInputDialogComponent, {
        width: width,
        data: {
          title: title,
          message: message,
          freeTextPrompt: 'Archive reason',
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (onClose) {
          onClose(result);
        }
      });
    }


}
